/* tslint:disable:variable-name */
import { Injectable, Inject } from '@angular/core';
import { ISchema, BasePersistentApiClient } from '../common/index';
import {
    instanceCodeClientT, IInstanceCodeClient, paramsBuilderT, IParamsBuilder
} from '../common/interfaces';
import { Field, BaseEntity } from '../common/meta';
import { AuthHttp } from '../authentication/authentication.service';
import { IGoogleProgrammaticInventory, IGoogleProgrammaticInventoryClient } from './interfaces';

export class GoogleProgrammaticInventory extends BaseEntity<IGoogleProgrammaticInventory>
    implements IGoogleProgrammaticInventory {

    public static readonly type: string = 'google_programmatic_inventory';

    @Field()
    id: string;

    @Field()
    name: string;

}

@Injectable()
export class GoogleProgrammaticInventoryClient
    extends BasePersistentApiClient<IGoogleProgrammaticInventory, never, never>
    implements IGoogleProgrammaticInventoryClient {

    protected static classConfig: ISchema = {
        apiResourceName: 'google_programmatic_inventories'
    };

    constructor(
        http: AuthHttp,
        @Inject(instanceCodeClientT) instanceCodeClient: IInstanceCodeClient,
        @Inject(paramsBuilderT) paramsBuilder: IParamsBuilder
    ) {
        super(http, instanceCodeClient, paramsBuilder);
    }

    protected implementationClass() {
        return GoogleProgrammaticInventory;
    }

}
